import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Cfg} from '../../../../../_config/gral.config';
@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['./nav-logo.component.scss']
})
export class NavLogoComponent implements OnInit {
  @Input() navCollapsed: boolean;
  @Output() onNavCollapse = new EventEmitter();
  public windowWidth: number;
  public title: string;
  constructor() {
    this.windowWidth = window.innerWidth;
    this.title=Cfg.navnombre;
  }

  ngOnInit() {
  }

  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;
      this.onNavCollapse.emit();
    }
  }

}
